<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div v-if="parentNom">
                    <div class="card">
                        <h5 class="card-header">{{$t('registers.nomenclatures.parentInfo')}}</h5>
                        <div class="card-body">
                            <div class="form-group">
                                <label class="font-weight-bold" for="parentNomId">{{ $t('registers.nomenclatures.gridHeaders.id')}}</label>
                                <input type="number" id="parentNomId" class="form-control" :disabled="true" :value="parentNom.id">
                            </div>
                            <div class="form-group">
                                <label class="font-weight-bold" for="parentNomName">{{ $t('registers.nomenclatures.gridHeaders.name')}}</label>
                                <input type="text" id="parentNomName" class="form-control" :disabled="true" :value="parentNom.name">
                            </div>
                            <div class="form-group">
                                <label class="font-weight-bold" for="parentNomNameEn">{{ $t('registers.nomenclatures.gridHeaders.nameEn')}}</label>
                                <input type="text" id="parentNomNameEn" class="form-control" :disabled="true" :value="parentNom.nameEn">
                            </div>
                            <div class="form-group">
                                <label class="font-weight-bold" for="parentNomSort">{{ $t('registers.nomenclatures.gridHeaders.sort')}}</label>
                                <input type="number" id="parentNomSort" class="form-control" :disabled="true" :value="parentNom.sort">
                            </div>
                        </div>
                    </div>

                    <div v-if="model" class="mt-3">
                        <div class="form-group">
                            <label class="font-weight-bold required" :for="'nomName' + _uid">{{ $t('registers.nomenclatures.gridHeaders.name')}}</label>
                            <input type="text" class="form-control"
                                   v-model="model.name"
                                   :name="'nomName' + _uid"
                                   :id="'nomName' + _uid"
                                   v-validate="'required'"
                                   :data-vv-as="$t('registers.nomenclatures.gridHeaders.name')">
                            <span class="text-danger">{{ errors.first('nomName' + _uid) }}</span>
                        </div>

                        <div class="form-group">
                            <label class="font-weight-bold" for="nomNameEn">{{ $t('registers.nomenclatures.gridHeaders.nameEn')}}</label>
                            <input type="text" id="nomNameEn" class="form-control" v-model="model.nameEn">
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer text-right" v-if="parentNom">
                <button type="button" class="btn btn-success" @click.stop="onSave"><i class="fas fa-save mr-2"></i>{{ $t('buttons.save.btnText')}}</button>
                <button type="button" class="btn btn-danger" @click.stop="onCancel"><i class="fas fa-ban mr-2"></i>{{ $t('buttons.cancel')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { Nomenclature, NomenclatureParent } from '../../models/models';
    import nomenclatureService from '../../services/nomenclature.service';

    export default {
        inject: ['$validator'],
        props: {
            nomSort: {
                type: Number,
                required: false
            },
            create: {
                type: Boolean,
                default: false
            },
            nomName: {
                type: String,
                required: false
            }
        },
        components: {

        },
        data() {
            return {
                parentSort: 0,
                parentNom: null,
                model: null,
            }
        },
        methods: {
            onCancel(e) {
                this.$emit("nomEditCancel", e);
            },
            onSave() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.doSave();
                    }
                });
            },
            doSave() {
                if (this.create && this.isNew) {
                    // Create
                    this.createNomenclature();
                } else {
                    // Update
                    this.updateNumenclature();
                }
            },
            loadParentNomBySort() {
                nomenclatureService
                    .getParentBySort(this.parentSort)
                    .then(response => {
                        let resultModel = response.data.model;

                        if (resultModel) {
                            this.parentNom = new Nomenclature(resultModel);
                            this.model = new Nomenclature({
                                parentId: this.parentNom.id,
                                parentModel: new NomenclatureParent({ id: this.parentNom.id, text: this.parentNom.name, textEn: this.parentNom.nameEn }),
                                sort: this.parentNom.sort
                            })
                        }
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            loadParentNomByName() {
                nomenclatureService
                    .getParentByName(this.nomName)
                    .then(response => {
                        let resultModel = response.data.model;

                        if (resultModel) {
                            this.parentNom = new Nomenclature(resultModel);
                            this.model = new Nomenclature({
                                parentId: this.parentNom.id,
                                parentModel: new NomenclatureParent({ id: this.parentNom.id, text: this.parentNom.name, textEn: this.parentNom.nameEn }),
                                sort: this.parentNom.sort
                            })
                        }
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            createNomenclature() {
                nomenclatureService
                    .create(this.model)
                    .then(response => {
                        let resultModel = response.data.model;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                        this.$emit("nomEditSave", resultModel);
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            updateNumenclature() {
                // Only create is allowed

                // nomenclatureService
                //    .update(this.model)
                //    .then(response => {
                //        this.$vs.notify({
                //            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                //            text: this.$helpers.responseMessage(response),
                //            color: 'success',
                //            time: this.$store.getters.notificationDuration
                //        });

                //        this.$emit("nomEditSave", this.model);
                //    })
                //    .catch(error => {
                //        this.$vs.notify({
                //            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                //            text: this.$helpers.errorText(error),
                //            color: this.$helpers.errorColor(error),
                //            time: this.$store.getters.notificationDuration
                //        })
                //    });
            }

        },
        computed: {
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
            isNew() {
                let id = Number(this.model.id);
                return isNaN(id) || id <= 0;
            }
        },
        mounted() {
            this.parentSort = this.nomSort;
            let parSort = Number(this.parentSort)
            if (!isNaN(parSort) && parSort > 0) {
                this.loadParentNomBySort();
            } else {
                if (this.nomName) {
                    this.loadParentNomByName();
                }
            }
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
